import React from "react";
import { BrowserRouter as Router, Routes } from "react-router-dom";
import routes from "./routes";
import Dashboard from "./components/Dashboard";
import { ThemeProvider } from "@emotion/react";
import theme from "./theme";
import { CssBaseline } from "@mui/material";
import { Toaster } from "react-hot-toast";

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Toaster
        position="bottom-left"
        toastOptions={{
          style: {
            borderRadius: "8px",
            background: "#333",
            color: "#fff",
            padding: "12px 16px",
            fontSize: "0.9rem",
          },
          success: {
            iconTheme: {
              primary: "#4caf50",
              secondary: "#fff",
            },
          },
          error: {
            iconTheme: {
              primary: "#f44336",
              secondary: "#fff",
            },
          },
        }}
      />
      <Router>
        <Dashboard>
          <Routes>{routes}</Routes>
        </Dashboard>
      </Router>
    </ThemeProvider>
  );
};

export default App;
